import { render } from "./addDelivre.vue?vue&type=template&id=29f191ac&scoped=true"
import script from "./addDelivre.vue?vue&type=script&lang=js"
export * from "./addDelivre.vue?vue&type=script&lang=js"

import "./addDelivre.vue?vue&type=style&index=0&id=29f191ac&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f191ac"]])

export default __exports__